import React, { useEffect, useRef, useState, lazy, Suspense } from 'react';
import {
	Button,
	Stack,
	TextField,
	FormControlLabel,
	Select,
	FormControl,
	Box,
	Typography,
} from '@mui/material';
import { dashboardUrl } from '../../../service/config';
import './Governance.scss';
import { useSearchParams } from 'react-router-dom';
import useStyles from '../../jobs/jobs_styles';
import Popover from '@mui/material/Popover';
import MenuItem from '@mui/material/MenuItem';
import Checkbox from '@mui/material/Checkbox';
import moment from 'moment';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { ReactComponent as DatePickerIcon } from '../../../assets/calendar-outline_white.svg';
import { ReactComponent as FilterIcon } from '../../../assets/ml_summary_filter.svg';
import { getDecodedToken, getSector } from '../../../service/service';
import { ReactComponent as ServerIcon } from '../../../assets/solar_server-outline.svg';
import { useTheme } from "@mui/material/styles";
const AnalyticsVisualization = lazy(() => import('../../framework/analyticsVisualization'));
const TableauDetailView = lazy(() => import('./DetailsView'));
const TableauGovernanceUsers = lazy(() => import('./Users'));
const TableauGovernanceOrphaned = lazy(() => import('./Orphaned'));
const SpaceUtilizedByUnused = lazy(() => import('./SpaceUtilizedByUnused'));


const Governance = () => {
	const theme = useTheme();
	const colors = theme.palette;
	const [searchParams, setSearchParams] = useSearchParams();
	const [usedWorkBook, setUsedWorkBook] = useState('30Days');
	const [usedExtracts, setUsedExtracts] = useState('30Days');
	const [usedViews, setUsedViews] = useState('30Days');
	const [unUsedExtracts, setUnUsedExtracts] = useState('');
	const [drillDownStatus, setDrillDownStatus] = useState<string | null>(searchParams.get('drillDownStatus') || 'all_used_workbooks');
	const [unusedExtractdrillDownStatus, setunusedExtractDrillDownStatus] = useState<string | null>(searchParams.get('drillDownStatus') || 'most_unUsed_extracts');
	const [drillDownFilter, setDrillDownFilter] = useState<string | null>(searchParams.get('drillDownFilter') || '30Days');
	const [totalOrphanType, setTotalOrphan] = useState<string | null>(searchParams.get('totalOrphanType') || null);
	const hasDrillDown = searchParams.has('isDrillDowned');
	const hasTotalSpaceUtilized = searchParams.has('isSpaceUtilized');
	const hasTotalOrphan = searchParams.has('isTotalOrphan');
	const dataFetchedRef = useRef(false);

	const [shouldScroll, setShouldScroll] = useState(false);

	const setupParamsForDaysFilterDrillDown = (days: string, status: string) => {
		setDrillDownFilter(days);
		setDrillDownStatus(status);
		setunusedExtractDrillDownStatus(status);
		resetSearchParams();
		if (hasTotalOrphan) {
			searchParams.delete('isTotalOrphan');
			searchParams.delete('totalOrphanType');
			setSearchParams(searchParams);
		}
		if (hasTotalSpaceUtilized) {
			searchParams.delete('isSpaceUtilized');
			searchParams.delete('drillDownStatus');
			setSearchParams(searchParams);
		}
	}
	const handleusedWorkBook = (days: string) => {
		setShouldScroll(true);
		setUsedWorkBook(days);
		setupParamsForDaysFilterDrillDown(days, "all_used_workbooks");
	};
	const handleusedExtracts = (days: string) => {
		setShouldScroll(true);
		setUsedExtracts(days);
		setupParamsForDaysFilterDrillDown(days, "all_used_extracts");
	};
	const handleusedViews = (days: string) => {
		setShouldScroll(true);
		setUsedViews(days);
		setupParamsForDaysFilterDrillDown(days, "all_used_views");
	};

	const handleUnUsedExtracts = (days: string) => {
		setDrillDownFilter(days);
		localStorage.setItem('selectedFilter', days);
		setUnUsedExtracts(days);
		setSearchParams(new URLSearchParams({
			...searchParams,
			isSpaceUtilized: 'true',
			drillDownStatus: 'most_unused_extracts',
			filter: days,
		}))
	};

	const dateFrom: string = searchParams.get('fromDate')?.substring(0, 10) as string;
	const startDt = moment(dateFrom).startOf('day').subtract(1, 'hours').format('YYYY-MM-DD');
	const [fromDateTime, setFromDateTime] = useState<any>(
		searchParams.has('fromDate') ? startDt : moment().startOf('day').subtract(1, 'hours')
	);
	const [propsFromDateTime, setPropsFromDateTime] = useState<any>(
		searchParams.has('fromDate') ? startDt : moment().startOf('day').subtract(1, 'hours')
	);

	// sector filter
	const userSector = getDecodedToken()?.sector?.name?.toLowerCase();
	const [filterMenu, setFilterMenu] = useState<{
		mouseX: number;
		mouseY: number;
	} | null>(null);
	const classes = useStyles();
	const [itemsChecked, setItemsChecked] = useState(false);
	const [sectorOptionsList, setSectorOptionsList] = useState<any[]>([]);
	const [checkedList, setCheckedList] = useState<any[]>([]);
	const [currSectorFilter, setCurrSectorFilter] = useState<any[]>([]);
	const [sector, setCurrSector] = useState<any[]>([]);
	//server filter
	const [instance, setInstance] = useState<any>('all');

	// [Date Range Menu]
	const [dateRangeMenuOpen, setDateRangeMenuOpen] = React.useState<null | HTMLElement>(null);

	const open = Boolean(dateRangeMenuOpen);

	const handleDateTimeChange = (field: any, dateTime: any) => {
		localStorage.setItem('selectedDateTime', dateTime);// Tableau drilldown filter changes
		if (field === 'fromDateTime') setFromDateTime(dateTime);
		applyDateTimeRange(dateTime);
	};

	const resetSearchParams = () => {
		if (searchParams.has('fromDate')) {
			searchParams.delete('status');
			searchParams.delete('scheduleDate');
			searchParams.delete('fromDate');
		}
		setSearchParams(searchParams);
	};
	const applyDateTimeRange = (dateTime: any) => {
		setPropsFromDateTime(dateTime);
		resetSearchParams();
		setDateRangeMenuOpen(null);
	};
	const sectorFilterClick = (event: any) => {
		setShouldScroll(false);
		event.preventDefault();
		setFilterMenu(
			filterMenu === null
				? {
					mouseX: parseInt(event.clientX) - 20,
					mouseY: parseInt(event.clientY) - 6
				}
				: null
		);
	};

	const handleClose = (event: any) => {
		setFilterMenu(null);
	};

	const selectAllCheck = (e: any) => {
		const { checked } = e.target;
		const collection: any[] = [];
		if (checked) setCheckedList(sectorOptionsList);
		else setCheckedList([]);
		setItemsChecked(checked);
	};
	const handleChange = (e: any) => {
		const { value, checked } = e.target;
		const newlyChecked = [];
		if (checked && e.target.value) {
			newlyChecked.push(e.target.value);
		}
		if (checked) {
			setCheckedList([...checkedList, ...newlyChecked]);
			if (sectorOptionsList.length === (checkedList.length + newlyChecked.length)) {
				setItemsChecked(true);
			}
		} else {
			setCheckedList(checkedList.filter((item) => item !== value));
			setItemsChecked(false);
		}
	};
	const handleOkClick = (event: any) => {
		localStorage.setItem('selectedSector', JSON.stringify(checkedList)); // Tableau drilldown filter changes
		if (checkedList.length > 0) {
			setCurrSectorFilter(checkedList);
		} else {
			setCurrSectorFilter([]);
		}
		setCurrSector(checkedList);
		handleClose(event);
		resetSearchParams();
	};

	async function fetchSectorOptionsData() {
		const sectorRes = await getSector('1', '100', '');
		if (sectorRes.success) {
			const filteredSectorOptions = sectorRes.data.sector.filter((x: any) => x.name !== 'S&T').map((x: any) => x.name);
			filteredSectorOptions.push('Blank');
			setSectorOptionsList(filteredSectorOptions);
		}
	}
	// Server filter code
	const handleServerChange = (field: any, selectedServer: any) => {
		// Tableau server filter changes
		localStorage.setItem('selectedServer', selectedServer.target.value);
		if (field === 'instance') setInstance(selectedServer.target.value);
		applyServerFilter(selectedServer.target.value);
	};
	const applyServerFilter = (selectedServer: any) => {
		setInstance(selectedServer);
		resetSearchParams();

	};
	useEffect(() => {
		const drillDownStatus = hasDrillDown ? searchParams.get('drillDownStatus') : 'all_used_workbooks';
		const days: any = hasDrillDown ? searchParams.get('drillDownFilter') : '30Days';
		if (hasDrillDown) {
			if (drillDownStatus?.includes('workbooks')) {
				setUsedWorkBook(days);
			} else if (drillDownStatus?.includes('extracts')) {
				setUsedExtracts(days);
			} else if (drillDownStatus?.includes('views')) {
				setUsedViews(days);
			}
			console.log(drillDownStatus, days, typeof days)
		}
		if (dataFetchedRef.current) return;
		dataFetchedRef.current = true;


		// Tableau drilldown filter changes
		if (hasDrillDown || hasTotalOrphan || hasTotalSpaceUtilized) {
			const selectedDateTime = localStorage.getItem('selectedDateTime')
			if (selectedDateTime) {
				setFromDateTime(selectedDateTime);
				setPropsFromDateTime(selectedDateTime);
			}
			const selectedSector = localStorage.getItem('selectedSector')
			if (selectedSector) {
				setCheckedList(JSON.parse(selectedSector));
				setCurrSector(JSON.parse(selectedSector));
				setCurrSectorFilter(JSON.parse(selectedSector));
			}
			const selectedServer = localStorage.getItem('selectedServer')
			if (selectedServer) {
				setInstance(selectedServer);
			}
			const selectedFilter = localStorage.getItem('selectedFilter')
			if (selectedFilter) {
				setUnUsedExtracts(selectedFilter);
			}
		} else {
			localStorage.removeItem('selectedDateTime')
			localStorage.removeItem('selectedFilter')
			localStorage.removeItem('selectedSector')
			localStorage.removeItem('selectedServer');
		}


		if (userSector === 'all') fetchSectorOptionsData();
		const url = window.location.pathname;
		const activeId = document.getElementById('root');
		if (window.location.pathname === '/tableau/governance/dashboard') {
			if (activeId) {
				activeId.classList.add('jobs-list-table');
				activeId.classList.remove('jobs-list', 'root');
				document.body.classList.add('jobs-exe-datas');
				document.body.classList.remove('jobs-run-table');
				document.body.classList.add('jobs-list-datas', 'databricks-jobs', 'datefilter-align-sector');
			}
		} else {
			if (activeId) {
				document.body.classList.remove('jobs-list-datas');
				activeId.classList.add('root');
				activeId.classList.remove('jobs-list-table', 'jobs-list');
				document.body.classList.remove('jobs-run-table', 'jobs-exe-datas');
			}
		}
	}, [])
	let fromDate = moment(propsFromDateTime).format('YYYY-MM-DD');
	return (
		<div className="dashboard-panel job-schedules-wrap">
			<Stack
				direction="row"
				spacing={2}
				justifyContent="flex-end"
				alignItems="center"
				sx={{ mt: 10 }}
			>
				{/* Date Range Filter */}
				<Box sx={{ backgroundColor: colors.backgroundLight.dark, borderRadius: 1, p: 1 }}>
					<LocalizationProvider dateAdapter={AdapterMoment}>
						<DatePicker
							showToolbar
							components={{ OpenPickerIcon: DatePickerIcon }}
							PopperProps={{
								placement: "auto",
								sx: {
									"& .MuiPaper-root": {
										backgroundColor: `${colors.dropdown.background} !important`,
									},
									"& .MuiPickersDay-root": {
										color: `${colors.dropdown.menuItemHoverText} !important`,
										"&.Mui-selected": {
											backgroundColor: `${colors.dropdown.menuItemSelected} !important`,
										},
										"&:hover": {
											backgroundColor: `${colors.dropdown.menuItemSelected} !important`,
										},
									},
									"& .MuiTypography-root": {
										color: `${colors.dropdown.menuItemHoverText} !important`,
									},
								},
							}}
							value={moment(fromDateTime).tz("America/New_York")}
							onChange={(dateTime) => handleDateTimeChange("fromDateTime", dateTime)}
							renderInput={(params: any) => (
								<TextField
									name="startDateTime"
									{...params}
									size="small"
									sx={{
										"& .MuiInputBase-root": {
											height: 36,
											...theme.typography.filterText,
										}
									}}
								/>
							)}
						/>
					</LocalizationProvider>
				</Box>

				{/* Sector Filter */}
				<Box
					sx={{
						backgroundColor: colors.backgroundLight.dark,
						borderRadius: "4px",
					}}
				>
					{userSector === "all" ? (
						<FilterIcon onClick={sectorFilterClick} style={{ cursor: "pointer" }} />
					) : (
						<Typography variant="filterText" sx={{ px: 1 }}>
							Sector: {getDecodedToken()?.sector?.name}
						</Typography>
					)}
					<Popover
						open={filterMenu !== null}
						onClose={handleClose}
						anchorReference="anchorPosition"
						anchorPosition={
							filterMenu !== null
								? { top: filterMenu.mouseY, left: filterMenu.mouseX }
								: undefined
						}
					>
						<Stack
							spacing={1}
							sx={{
								backgroundColor: `${colors.dropdown.menuItemBackground} !important`,
								p: 2,
								minWidth: 200,
								maxHeight: 250,
								overflowY: "auto",
							}}
						>
							{/* All checkbox */}
							<MenuItem
								disableGutters
								selected={itemsChecked}
								sx={{
									...theme.typography.filterText,
									backgroundColor: `${colors.dropdown.menuItemBackground} !important`,
									color: `${colors.dropdown.menuItemText} !important`,
									"&:hover": {
										backgroundColor: `${colors.dropdown.menuItemHover} !important`,
										"& .MuiFormControlLabel-label": {
											color: `${colors.dropdown.menuItemHoverText} !important`,
										},
									},
								}}
							>
								<FormControlLabel
									label={<Typography variant="filterText">All</Typography>}
									sx={{
										"& .MuiFormControlLabel-label": {
											color: `${colors.dropdown.menuItemText} !important`,
										},
									}}
									control={
										<Checkbox
											color="success"
											value="all"
											checked={itemsChecked}
											onChange={(e) => selectAllCheck(e)}
											sx={{
												"& .MuiSvgIcon-root": {
													color: `${colors.dropdown.checkBox} !important`,
												},
											}}
										/>
									}
								/>
							</MenuItem>

							{sectorOptionsList &&
								sectorOptionsList.map((filter: any) => (
									<MenuItem
										key={filter}
										disableGutters
										selected={checkedList.includes(filter)}
										sx={{
											...theme.typography.filterText,
											backgroundColor: `${colors.dropdown.menuItemBackground} !important`,
											color: `${colors.dropdown.menuItemText} !important`,
											"&:hover": {
												backgroundColor: `${colors.dropdown.menuItemHover} !important`,
												"& .MuiFormControlLabel-label": {
													color: `${colors.dropdown.menuItemHoverText} !important`,
												},
											},
										}}
									>
										<FormControlLabel
											label={
												<Typography variant="filterText">
													{filter === true ? 'Yes' : filter === false ? 'No' : filter}
												</Typography>
											}
											sx={{
												"& .MuiFormControlLabel-label": {
													color: `${colors.dropdown.menuItemText} !important`,
												},
											}}
											control={
												<Checkbox
													color="success"
													value={filter}
													checked={checkedList.includes(filter)}
													onChange={(e) => handleChange(e)}
													sx={{
														"& .MuiSvgIcon-root": {
															color: `${colors.dropdown.checkBox} !important`,
														},
													}}
												/>
											}
										/>
									</MenuItem>
								))}
						</Stack>

						{/* Action buttons */}
						<Stack direction="row" spacing={1} justifyContent="flex-end">
							<Button variant="contained" className={classes.cancelBtn} onClick={handleClose}>
								Cancel
							</Button>
							<Button variant="contained" className={classes.okBtn} onClick={handleOkClick}>
								Ok
							</Button>
						</Stack>
					</Popover>
				</Box>

				{/* Server Filter */}
				<Box
					sx={{
						backgroundColor: colors.backgroundLight.dark,
						borderRadius: 1,
						p: 1,
						display: "flex",
						alignItems: "center",
						minWidth: 160,
					}}
				>
					<FormControl fullWidth size="small">
						<Stack direction="row" alignItems="center" spacing={1}>
							<ServerIcon />
							<Select
								name="server-select"
								id="single-server-select"
								value={instance}
								onChange={(e) => handleServerChange("instance", e)}
								IconComponent={() => null}
								sx={{
									minWidth: 120,
									height: 36,
									"& .MuiSelect-select": {
										...theme.typography.filterText,
									},
								}}
								MenuProps={{
									PaperProps: {
										sx: {
											backgroundColor: `${colors.dropdown.menuItemBackground} !important`,
											color: `${colors.dropdown.menuItemText} !important`,
										},
									},
									MenuListProps: { sx: { p: 0 } },
								}}
							>
								{["all", "global", "cockpit"].map((val) => (
									<MenuItem
										key={val}
										value={val}
										sx={{
											...theme.typography.filterText,
											backgroundColor: `${colors.dropdown.menuItemBackground} !important`,
											color: `${colors.dropdown.menuItemText} !important`,
											"&.Mui-selected": {
												backgroundColor: `${colors.dropdown.menuItemSelected} !important`,
												color: `${colors.dropdown.menuItemHoverText} !important`,
											},
											"&.Mui-selected:hover": {
												backgroundColor: `${colors.dropdown.menuItemHover} !important`,
												color: `${colors.dropdown.menuItemHoverText} !important`,
											},
											"&:hover": {
												backgroundColor: `${colors.dropdown.menuItemHover} !important`,
												color: `${colors.dropdown.menuItemHoverText} !important`,
											},
										}}
									>
										{val === "all"
											? "All Servers"
											: val.charAt(0).toUpperCase() + val.slice(1)}
									</MenuItem>
								))}
							</Select>
						</Stack>
					</FormControl>
				</Box>
			</Stack>
			<Stack>
				<div className="governance-container-main">
					<div className="workBook-iframe-div-governance">
						<div className="work-book">
							<span
								className={'types ' + (usedWorkBook === '30Days' ? 'active' : '')}
								onClick={() => handleusedWorkBook('30Days')}
							>
								30 Days
							</span>
							<span
								className={'types ' + (usedWorkBook === '60Days' ? 'active' : '')}
								onClick={() => handleusedWorkBook('60Days')}
							>
								60 Days
							</span>
							<span
								className={'types ' + (usedWorkBook === '90Days' ? 'active' : '')}
								onClick={() => handleusedWorkBook('90Days')}
							>
								90 Days
							</span>
						</div>
						<Suspense fallback={<div>Loading...</div>}>
							<AnalyticsVisualization
								params={{
									dashboardUrl: dashboardUrl.tableauGovernance,
									className: 'tableauGovernanceWorkBookContainer',
									otherParams: {
										'var-filterusedWorkBook': usedWorkBook,
										'var-fromDate': fromDate,
										'var-sector': currSectorFilter,
										'var-server': instance
									},
									seamless: true
								}}
							/>
						</Suspense>
					</div>
					<div className="extracts-iframe-div-governance">
						<div className="extract-book">
							<span
								className={'types ' + (usedExtracts === '30Days' ? 'active' : '')}
								onClick={() => handleusedExtracts('30Days')}
							>
								30 Days
							</span>
							<span
								className={'types ' + (usedExtracts === '60Days' ? 'active' : '')}
								onClick={() => handleusedExtracts('60Days')}
							>
								60 Days
							</span>
							<span
								className={'types ' + (usedExtracts === '90Days' ? 'active' : '')}
								onClick={() => handleusedExtracts('90Days')}
							>
								90 Days
							</span>
						</div>
						<Suspense fallback={<div>Loading...</div>}>
							<AnalyticsVisualization
								params={{
									dashboardUrl: dashboardUrl.tableauGovernanceMostUsedExtract,
									className: 'tableauGovernanceExtractsContainer',
									otherParams: {
										'var-filterusedExtracts': usedExtracts,
										'var-fromDate': fromDate,
										'var-sector': currSectorFilter,
										'var-server': instance
									},
									seamless: true
								}}
							/>
						</Suspense>
					</div>
					<div className="views-iframe-div-governance">
						<div className="views-book">
							<span
								className={'types ' + (usedViews === '30Days' ? 'active' : '')}
								onClick={() => handleusedViews('30Days')}
							>
								30 Days
							</span>
							<span
								className={'types ' + (usedViews === '60Days' ? 'active' : '')}
								onClick={() => handleusedViews('60Days')}
							>
								60 Days
							</span>
							<span
								className={'types ' + (usedViews === '90Days' ? 'active' : '')}
								onClick={() => handleusedViews('90Days')}
							>
								90 Days
							</span>
						</div>
						<Suspense fallback={<div>Loading...</div>}>
							<AnalyticsVisualization
								params={{
									dashboardUrl: dashboardUrl.tableauGovernanceMostUsedViews,
									className: 'tableauGovernanceViewsContainer',
									otherParams: {
										'var-filterusedViews': usedViews,
										'var-fromDate': fromDate,
										'var-sector': currSectorFilter,
										'var-server': instance
									},
									seamless: true
								}}
							/>
						</Suspense>
					</div>
				</div>
				<div className="governance-container-sub">
					<div className="orphaned-iframe-div-governance">
						<Suspense fallback={<div>Loading...</div>}>
							<AnalyticsVisualization
								params={{
									dashboardUrl: dashboardUrl.tableauGovernanceOrphaned,
									className: 'tableauGovernanceOrphanedIframeContainer',
									otherParams: {
										'var-sector': currSectorFilter,
										'var-fromDate': fromDate,
										'var-server': instance
									},
									seamless: true
								}}
							/>
						</Suspense>
					</div>
					<div className="unusedExtracts-iframe-div-governance">
						<div className="unUsed-extracts">
							<span
								className={'types ' + (unUsedExtracts === '30Days' ? 'active' : '')}
								onClick={() => handleUnUsedExtracts('30Days')}
							>
								30 Days
							</span>
							<span
								className={'types ' + (unUsedExtracts === '60Days' ? 'active' : '')}
								onClick={() => handleUnUsedExtracts('60Days')}
							>
								60 Days
							</span>
						</div>
						<Suspense fallback={<div>Loading...</div>}>
							<AnalyticsVisualization
								params={{
									dashboardUrl: dashboardUrl.tableauGovernanceUnusedExtracts,
									className: 'tableauGovernanceUnusedExtractsIframeContainer',
									otherParams: {
										'var-filter': unUsedExtracts,
										'var-fromDate': fromDate,
										'var-sector': currSectorFilter,
										'var-server': instance
									},
									seamless: true
								}}
							/>
						</Suspense>
					</div>
				</div>
			</Stack>
			{hasTotalOrphan ? (
				<Suspense fallback={<div>Loading...</div>}>
					<TableauGovernanceOrphaned
						fromDateTime={propsFromDateTime}
						sectorFilter={sector}
						totalOrphanType={totalOrphanType}
						instance={instance}
					/>
				</Suspense>
			) : (
				<>
					{hasTotalSpaceUtilized ? (
						<Suspense fallback={<div>Loading...</div>}>
							<SpaceUtilizedByUnused fromDateTime={propsFromDateTime}
								sectorFilter={sector}
								drillDownStatus={unusedExtractdrillDownStatus}
								drillDownFilter={drillDownFilter} instance={instance} />
						</Suspense>
					) : (
						<>
							<Suspense fallback={<div>Loading...</div>}>
								<TableauGovernanceUsers
									fromDateTime={propsFromDateTime}
									sectorFilter={sector}
									instance={instance}
									drillDownFilter={drillDownFilter} />
							</Suspense>
							<Suspense fallback={<div>Loading...</div>}>

								<TableauDetailView
									fromDateTime={propsFromDateTime}
									sectorFilter={sector}
									drillDownStatus={drillDownStatus}
									drillDownFilter={drillDownFilter}
									instance={instance}
									shouldScroll={shouldScroll}
								/>
							</Suspense>
						</>
					)}
				</>
			)}
		</div>

	);
};

export default Governance;
